import React from 'react';
import { StyleSheet } from 'react-native';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { EsVerticalCard, VerticalCarousel } from '../EsCards/EsVerticalCard';
import { ViewAll } from '../ViewAll/ViewAll';
import { isEmpty } from '../../utils/lodash';
import { ISubmission } from '../../types/global/helper';

export interface ITopPerformersCarousel extends Omit<VerticalCarousel, 'submission'> {
    submissionData?: ISubmission[];
    onClickViewAll?: () => void;
}

const EsTopPerformersCarousel: React.FC<ITopPerformersCarousel> = ({ submissionData, onClickViewAll, onClickPlay }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Box
            style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: '36px',
            }}>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <Typography style={styles.text}>Top performers</Typography>
                <ViewAll onClickViewAll={onClickViewAll} themeStyle={themeStyle} />
            </Box>
            <Box
                style={{
                    width: '100%',
                    height: 'fit-content',
                    display: 'flex',
                    overflowX: 'scroll',
                    gap: '24px',
                }}
                sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
                {submissionData &&
                    !isEmpty(submissionData) &&
                    submissionData.map(
                        (item, index) =>
                            item.project &&
                            item.project && (
                                <EsVerticalCard submission={item as any} key={index} onClickPlay={onClickPlay} />
                            ),
                    )}
            </Box>
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        text: {
            textAlign: 'left',
            fontSize: 24,
            fontStyle: 'normal',
            fontWeight: '600',
            color: theme[colorScheme].filters_white,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        link: {
            textAlign: 'left',
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: '600',
            color: theme[colorScheme].primary_orange,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
    });

export { EsTopPerformersCarousel };
